/** @jsx jsx */
import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Link } from '@zapier/design-system';
import { skipLinkHref } from '../../constants';

type Props = {
  /**
   * Anchor to the main content area of the page.
   * **The page must contain a node with the `id` in this prop!**
   */
  href?: string;
  /**
   * Link text.
   */
  text?: string;
};

const Styles = labelStyles('SkipLink', {
  root: {
    fontSize: 10,
    textTransform: 'uppercase',
    display: 'block',
    color: 'var(--zds-text-weaker, #574E4C)',
    // Hide the link and make it unclickable.
    opacity: 0,
    pointerEvents: 'none',
    textDecoration: 'none',

    // Only show the link on focus.
    '&:focus': {
      opacity: 1,
      outline: 'none',
    },
  },
});

/**
 * @private
 * Renders an invisible "Skip To Content" link, which becomes visible only if the element receives focus.
 * This improves the browsing experience for users on screenreaders.
 */
const SkipLink = ({ href = skipLinkHref, text = 'Skip to content' }: Props) => {
  return (
    <Link
      // Without the `main`, screen reader will read this as `Skip to conTENT`
      ariaLabel="Skip to main content"
      css={Styles.root}
      href={href}
    >
      {text}
    </Link>
  );
};

export default SkipLink;
